import type { GameRow } from '../ValueDashboard/types';

/** Kalshi legs for a game row, or null when either leg is missing. Consumed by
 * the Sniper (useSniper + the dashboard target link); the Larry cockpit that
 * used to live beside it was pruned. */
export function larryLegsOf(game: GameRow): { tickerA: string; tickerB: string } | null {
  const a = game.kalshi?.away?.marketTicker;
  const b = game.kalshi?.home?.marketTicker;
  return a && b ? { tickerA: a, tickerB: b } : null;
}
